var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wux-nav"},[(_vm.back)?_c('div',{staticClass:"wux-nav-left",on:{"click":_vm.goBack}},[_c('div',{staticClass:"hand"},[_c('span',{staticClass:"icon icon-109"}),_vm._v(_vm._s(_vm.$t('back')))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"wux-nav-title"},[_vm._t("default")],2),_vm._v(" "),_c('div',{staticClass:"wux-nav-right"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-33a3bddb","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/myNav.vue
// module id = null
// module chunks = 